import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowRight } from "lucide-react";
import { POSTS } from "@/data/posts";
import { Reveal } from "@/components/Reveal";

export default function BlogIndex() {
  return (
    <>
      <Helmet>
        <title>Spring Engineering Journal | Material Guides, Failure Analysis & Specification | MESCO Springs</title>
        <meta name="description" content="Technical articles from 55 years of spring manufacturing: material selection (Inconel vs stainless, Monel vs 316), spring specification guides, fatigue failure analysis and more. MESCO Springs Mumbai." />
      </Helmet>
      <div className="pt-40 pb-16 border-b border-[#334772]/15 blueprint-grid" data-testid="blog-hero">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <p className="font-mono-spec text-[11px] tracking-[0.35em] uppercase text-[#334772]">[ ENGINEERING JOURNAL ]</p>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl uppercase leading-[0.9] text-[#334772] mt-6">
              55 years of<br />spring knowledge
            </h1>
            <p className="mt-6 max-w-2xl text-[#706F70] leading-relaxed">
              Material selection, specification guides and failure analysis — written by the people who coil the wire.
            </p>
          </Reveal>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#334772]/10 border border-[#334772]/15">
        {POSTS.map((p, i) => (
          <Reveal key={p.slug} delay={(i % 2) * 0.08}>
            <Link
              to={`/journal/${p.slug}`}
              data-testid={`post-card-${p.slug}`}
              className="group block bg-[#F3F5F8] p-10 h-full hover:bg-[#F3F5F8] hover:-translate-y-1 transition-all duration-300 border border-transparent hover:border-[#334772]"
            >
              <div className="flex items-center gap-4 font-mono-spec text-[10px] tracking-[0.25em] uppercase text-[#9C9C9C]">
                <span className="text-[#334772]">{p.tag}</span>
                <span>{p.date}</span>
                <span>{p.readTime}</span>
              </div>
              <h2 className="font-display text-3xl lg:text-4xl text-[#334772] uppercase tracking-wide leading-tight mt-4 group-hover:text-[#706F70] transition-colors duration-200">
                {p.title}
              </h2>
              <p className="mt-4 text-sm text-[#706F70] leading-relaxed italic border-l-2 border-[#334772]/50 pl-4">"{p.pullQuote}"</p>
              <span className="mt-6 inline-flex items-center gap-2 font-mono-spec text-[10px] tracking-[0.2em] uppercase text-[#334772]">
                Read article <ArrowRight className="w-3 h-3 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </>
  );
}
